import { BrBreadcrumbs } from '@govbr-ds/react-components';
import { ICrumb } from '../../../interfaces/ICrumb';
import styles from './breadcrumb.module.scss';

interface BreadcrumbProps {
  crumbs: ICrumb[] | undefined;
}

function Breadcrumb({ crumbs }: BreadcrumbProps) {
  const crumbsUsed = crumbs || [];

  return <div className={styles.container}>{crumbsUsed && <BrBreadcrumbs crumbs={crumbsUsed} />}</div>;
}

export default Breadcrumb;
